import { IItemOrcamento } from "app/types/IItemOrcamento"
import { Dict } from "app/utils/Dict"
import { EntitesDadosEstoque } from "../../Estoque"
import { useEffect, useRef, useState } from "react"
import { NotasFiscaisPendentes } from "./NotasFiscaisPendentes"
import { Parametro } from "app/types/Parametro"
import { obterParametros } from "app/use-cases/parametro/obterParametros"
import globalMU from "globalMU"
import microuniversoApi from "app/api/microuniversoApi"
import { tratamentoErroPadrao } from "app/use-cases"
import { useMenuSubConsulta } from "app/components/menu-sub-consulta-produto/useMenuSubConsultaProduto"
import { useMenuConsultaProduto } from "app/components/menu-consulta-produtos/useMenuConsultaProduto"
import React from "react"
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container"

export type NotasFiscaisPendentesProps = {
    estoqueSelecionado: EntitesDadosEstoque,
    item: IItemOrcamento,
    tipoEntrega: string,
    onVoltar: () => void,
    onRemover: () => void,
    passos: Dict<string,() => void>,
    foraOrcamento: boolean 
}

export type ObterNotasFiscaisPendentesApi = {
    CodigoProduto: string
    CodigoFilial: string
    TipoEntrega: string
}

export const NotasFiscaisPendentesContainer = (props: NotasFiscaisPendentesProps) => {
    
    const [dadosNotasFiscaisPendentes, setDadosNotasFiscaisPendentes] = useState<NotasFiscaisPendentes[]>(null)
    const [parametros, setParametros] = useState<Parametro[]>([])
    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map))) 

    const atualizarParametros = async () => {
        setParametros(
            await obterParametros({
            nomes: [
                "ORCAMENTO_MASCARA_QUANTIDADE"
            ]
            })
        )
    }
    const valorParametro = (nome: string) => parametros.find((p) => p.Nome == nome)?.Valor;

    const onObterNotasFiscaisPendentes = async () => {
        try {
            globalMU.blockUI()
            const resposta = await microuniversoApi.Produto.obterNotasFiscaisPendentes({
                CodigoProduto: props.estoqueSelecionado.Codigo,
                CodigoFilial: props.estoqueSelecionado.Filial,
                TipoEntrega: props.tipoEntrega
            })
            !("HasErrors" in resposta) ? setDadosNotasFiscaisPendentes(resposta) : setDadosNotasFiscaisPendentes([])
        } catch (e) {
            tratamentoErroPadrao(e)
        } finally {
            globalMU.unblockUI()
        }
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }

    useMenuSubConsulta(props)
    useMenuConsultaProduto(new Dict(Object.assign({}, props.passos.remove("Estoque do Produto").map)), props.onVoltar, props.item, props.foraOrcamento)

    useEffect(() => {
        passosInterno.current.set("Estoque do Produto", () => props.onVoltar())
        atualizarParametros()
        onObterNotasFiscaisPendentes()
        if (props.tipoEntrega == "E") {
            passosInterno.current.set("Não Entregue Expedição", () => onObterNotasFiscaisPendentes())
        }
        else if (props.tipoEntrega == "F") {
            passosInterno.current.set("Não Entregue Futura", () => onObterNotasFiscaisPendentes())
        }
    }, [])

    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                onBotaoVoltarClicado={onVoltar}
                onPassoSelecionado={onPassoSelecionado}
                id="NotasFiscaisPendentesBreadcrumb"
            />
            <br />

            {dadosNotasFiscaisPendentes && <NotasFiscaisPendentes 
                produto={props.estoqueSelecionado.Codigo}
                descricao={props.estoqueSelecionado.Descricao}
                dados={dadosNotasFiscaisPendentes}
                orcamentoMascaraQuantidade={valorParametro("ORCAMENTO_MASCARA_QUANTIDADE")}    
            />}  
        </>
    )

}